module.exports = __webpack_public_path__ + "img/7.0ef95bcf.jpg";